import styled from 'styled-components'
import { media, colors } from 'styles'

const StyledHelp = styled.section`
  display: flex;
  padding: 2rem 1rem 8rem;
  flex-wrap: wrap;

  .questions,
  .form {
    flex: 1;
    margin: 0 1rem 3rem;
  }

  a[href='javascript:void(0)'] {
    display: none;
  }

  strong {
    color: ${colors.textSectionTitle};
  }

  a {
    color: inherit;
  }

  p,
  li {
    font-size: 1.4rem;
    line-height: 1.5;
    margin: 1.6rem 0;
  }

  ${media.mobile`
    flex-direction: column;

    .questions, .form {
      margin-left: 0;
      margin-right: 0;
    }
  `}
`

export const StyledQuestion = styled.div`
  .help-title {
    cursor: pointer;
    position: relative;
    font-size: 1.8rem;
    padding-left: 2rem;
    margin: 2rem 0 0;
    color: ${colors.textSectionTitle};

    &::before {
      content: '';
      border-style: solid;
      border-width: 0 3px 3px 0;
      padding: 3px;
      transform: rotate(-45deg);
      transition: transform 0.33s linear;
      margin-right: 1rem;
      vertical-align: 0.3rem;
      position: absolute;
      left: 0rem;
      top: 0.7rem;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  .help-content {
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    height: 0;
    margin: 0;
    padding-left: 0;
    transition: display 0s, visibility 0s 0.5s, opacity 0.5s, transform 0.5s;
  }

  &.active {
    .help-title::before {
      transform: rotate(45deg);
      transition: transform 0.33s linear;
    }

    .help-content {
      transform: translate3d(0, 1.6rem, 0);
      padding-bottom: 1.6rem;
      padding-right: 2.6rem;
      display: block;
      visibility: visible;
      opacity: 1;
      transition-delay: 0s;
      height: auto;
    }
  }
`

export const StyledContactForm = styled.form`
  .form-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 1.5rem;

    &.hidden {
      display: none;
    }
  }

  label {
    flex: 1;
    font-size: 1.4rem;
  }

  .input-area {
    flex: 3;
  }

  input,
  textarea,
  select {
    display: block;
    width: 100%;
  }

  .textarea-item {
    display: block;
  }

  textarea {
    min-height: 10rem;
    margin-top: 1rem;
    padding: 0.8rem;
    resize: none;
  }

  .captcha-item {
    margin-bottom: 1rem;
  }

  .submit {
    line-height: 3rem;
    padding: 1rem 2rem;
    font-size: 2rem;
    border-radius: 0.8rem;
    border: 0.1rem solid ${colors.textMain};
    cursor: pointer;
    text-transform: uppercase;
  }

  ${media.mobile`
    .form-item {
      flex-direction: column;
    }
    label, .input-area {
      width: 100%;
    }
  `}
`
export default StyledHelp
